<template>
	<div class="formulario-secciones" v-if="estructura && estructura.length" v-loading="loading">

        <!-- Version reducida que solo se ven los botones y el logo en grande -->
        <div v-if="versionReducida" class="form-lite">

            <!-- LOGO -->
            <img :src="require('@/assets/dooxSign.png')" />

            <el-button
                v-if="showAutofirma"
                @click="autoFirma = true"
                type="primary">Firmar ahora
            </el-button>

            <el-button 
                @click="versionReducida = false"
                type="primary">Enviar para firmar</el-button>
        </div>

        <!-- Version ampliada donde se ve el formulario y los botones en el inferior -->
        <div class="secciones">
            <section v-for="seccion in secciones" :key="seccion.id">
                <div :class="['section-title', {'no-title': !seccion.title}]">
                    <template v-if="seccion.title">
                        <div class="section-title-content">
                            <div>{{seccion.id}}</div>
                            <p> {{seccion.title}}</p>
                        </div>
                        <i class="el-icon-arrow-right"></i>
                    </template>
                </div>
                <ul class="formulario-nuevo-documento">
                    <li
                    v-for="(data, d) in estructura.filter(f => f[0].seccion == seccion.id)"
                    :key="d"
                    :class="[
                        estructura[d].some(e => e && ['editable','readonly','read-only'].includes(e.state) && e.visible) ? 'visible' : 'no-visible',
                        {hidden: data.every(s => !s.visible)}
                    ]">
                        
                        <el-row :gutter="5">

                            <el-col
                            v-for="(input,i) in data"
                            :key="i"
                            :span="input.attr.hasOwnProperty('col') ? input.attr.col : 24"
                            :style="{'height': input.format == 'textarea' ? 'fit-content' : 'auto'}">
                                
                                <div :ref="`formgroup_${seccion.id}_${d}_${i}`" class="form-group" :style="{flexFlow: input.attr.align == 'inline' ? 'row' : 'column' }" v-loading="input.loading">
                                    <label>{{data[i].title}}</label>
                                    <div class="form-input">
                                        <InputSigarus
                                            :busy.sync="input.loading"
                                            v-show="input.hasOwnProperty('visible') && input.visible"
                                            :identificador="id"
                                            :entidad="entidad"
                                            :entidadUrl="input.entidadUrl"
                                            :multiple="input.multiple"
                                            :siblings="inputList"
                                            ref="input"
                                            :input="input"
                                            :saveUrl="''"
                                            :type="input.format.includes('numeric') ? 'number' : input.format" 
                                            :obligatorio="!!input.obligatorio"
                                            :value="input.format == 'datepicker' ? ['0000-00-00',null,'',undefined].includes(input.value) ? '' : moment(input.value,'YYYY-MM-DD').format('DD/MM/yyyy') : input.value"
                                            :placeholder="input.placeholder"
                                            :readonly="(isExtraType(input) && ['id'].includes(isExtraType(input)) ? true : input.state == 'read-only') || (input.state == 'read-only')"
                                            :textPre="input.textpre"
                                            :textPos="input.textpos"
                                            :options="input.options"
                                            @input="val => input.value = input.format == 'datepicker' ? moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD') : val"
                                            @id="input => $emit('setActionId', input)"
                                            @go="inputGo"
                                            @saved="val => $emit('saved', val)"
                                            @obligatorio="foc(`formgroup_${d}_${i}`, ['form-group focused obligatorio'])"
                                            @focus="foc(`formgroup_${seccion.id}_${d}_${i}`, ['form-group focused'])"
                                            @blur="blur(`formgroup_${seccion.id}_${d}_${i}`, ['form-group'])"
                                            :actions="actionsByInput(input)"
                                            :porlet="porlet"
                                        />

                                        <template v-if="!['text:id','hidden:id'].includes(input.format)">
                                            <el-tooltip 
                                            v-for="action in actionsByInput(input)"
                                            class="item" 
                                            effect="dark" 
                                            :content="action ? action.titulo : ''" 
                                            placement="top">
                                                <el-button
                                                v-if="action"
                                                @click="porlet.events.clickAction(action)"
                                                type="default" 
                                                size="mini" 
                                                :icon="action.icon"
                                                />
                                            </el-tooltip>
                                        </template>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </li>
                </ul>
            </section>
        </div>

        <!-- Acciones generales -->
        <div class="formulario-buttons" :style="{justifyContent: showAutofirma ? 'space-between' : 'flex-end'}">
            <el-button
                v-if="showAutofirma"
                @click="autoFirma = true"
                plain
                type="primary">Firmar ahora
            </el-button>

            <!-- Resto de botones -->
            <div>
                <el-button 
                    v-for="(button,i) in fichaInicial.attr.buttons" 
                    :key="i"
                    @click="actionForm(button)"
                    type="primary">{{button.title}}</el-button>
            </div>
        </div>

        <!-- Autofirma -->
        <el-dialog
            :visible.sync="autoFirma"
            append-to-body
            @close="handleCloseAutofirma()"
            class="dialog-autofirma">

            <ul 
                v-if="estructura && estructura.length" 
                class="formulario-nuevo-documento">
                    <li
                    v-for="(data, d) in estructura.filter(f => f[0].seccion == 'autofirma')"
                    :key="d"
                    :class="[
                        estructura[d].some(e => e && ['editable','readonly','read-only'].includes(e.state) && e.visible) ? 'visible' : 'no-visible',
                        {hidden: data.every(s => !s.visible)}
                    ]">
                        
                        <el-row :gutter="5">

                            <el-col
                            v-for="(input,i) in data"
                            :key="i"
                            :span="input.attr.hasOwnProperty('col') ? input.attr.col : 24"
                            :style="{'height': input.format == 'textarea' ? 'fit-content' : 'auto'}">
                                
                                <div :ref="`formgroup_autofirma_${d}_${i}`" class="form-group" :style="{flexFlow: input.attr.align == 'inline' ? 'row' : 'column' }" v-loading="input.loading">
                                    <label>{{data[i].title}}</label>
                                    <div class="form-input">
                                        <InputSigarus
                                            :busy.sync="input.loading"
                                            v-show="input.hasOwnProperty('visible') && input.visible"
                                            :identificador="id"
                                            :entidad="entidad"
                                            :siblings="inputList"
                                            ref="input"
                                            :input="input"
                                            :saveUrl="''"
                                            :type="input.format.includes('numeric') ? 'number' : input.format" 
                                            :obligatorio="!!input.obligatorio"
                                            :value="input.format == 'datepicker' ? ['0000-00-00',null,'',undefined].includes(input.value) ? '' : moment(input.value,'YYYY-MM-DD').format('DD/MM/yyyy') : input.value"
                                            :placeholder="input.placeholder"
                                            :readonly="(isExtraType(input) && ['id'].includes(isExtraType(input)) ? true : input.state == 'read-only') || (input.state == 'read-only')"
                                            :textPre="input.textpre"
                                            :textPos="input.textpos"
                                            :options="input.options"
                                            @input="val => input.value = input.format == 'datepicker' ? moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD') : val"
                                            @id="input => $emit('setActionId', input)"
                                            @go="inputGo"
                                            @saved="val => $emit('saved', val)"
                                            @obligatorio="foc(`formgroup_${d}_${i}`, ['form-group focused obligatorio'])"
                                            @focus="foc(`formgroup_autofirma_${d}_${i}`, ['form-group focused'])"
                                            @blur="blur(`formgroup_autofirma_${d}_${i}`, ['form-group'])"
                                            :actions="actionsByInput(input)"
                                            :porlet="porlet"
                                        />

                                        <template v-if="!['text:id','hidden:id'].includes(input.format)">
                                            <el-tooltip 
                                            v-for="action in actionsByInput(input)"
                                            class="item" 
                                            effect="dark" 
                                            :content="action ? action.titulo : ''" 
                                            placement="top">
                                                <el-button
                                                v-if="action"
                                                @click="porlet.events.clickAction(action)"
                                                type="default" 
                                                size="mini" 
                                                :icon="action.icon"
                                                />
                                            </el-tooltip>
                                        </template>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </li>
                </ul>

            <span slot="footer" class="dialog-footer">
                <el-button @click="autoFirma = false">Cancelar</el-button>
                <el-button
                    v-for="(button,i) in fichaInicial.attr.buttons"
                    :key="i"
                    @click="actionForm(button)"
                    type="primary">Firmar</el-button>
            </span>
        </el-dialog>
        
    </div>
</template>

<script>
    import InputSigarus from '@/components/inputs/InputSigarus.vue'

    import Editor from '@/components/Editor/Editor.vue'

    import { mapState } from 'vuex'
    import { 
        getEstructuraFormulario,
        postActionData
    } from '@/helpers/api'

    import moment from 'moment'

	export default {
        name: 'Form',
        components: {
            InputSigarus,
            Editor
        },
		props: {
            ficha: {
                type: Object,
                required: false,
                default: () => null
            },
            entidad: String,
            url: {
                type: String,
                required: false,
                default: () => null
            },
            objects: {
                type: Array,
                required: false,
                default: () => null
            },
            id: [Number,String],
            autosave: {
                type: Boolean,
                required: false,
                default: () => true
            },
            divider: {
				type: Boolean,
				required: false,
				default: () => true
            },
            focus: {
				type: Boolean,
				required: false,
				default: () => false
            },
            inputList: Array,
            visibleLabel: {
                type: Boolean,
                required: false,
                default: () => true
            },
            porlet: {
                type: Object
            }
        },
		data () {
            return {
                moment,
                apiUrl: '',
                estructura: null,
                currentAction: null,
                fichaInicial: null,
                formularioInicial: null,
                loading: false,
                inputsTypeGoId: ['id','go','botongo','botonid'],
                secciones: [{
                    id: 1,
                    title: "Subida de documento"
                }, {
                    id: 2,
                    title: "Opciones"
                }, {
                    id: 3,
                    title: "Firmantes y destinatarios"
                }],
                showAutofirma: false,
                autoFirma: false,
                versionReducida: false
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.data,
                config: state => state.config.data
            })
        },
        watch: {
            objects: {
                handler() {
                    this.init()
                },
                deep: true
            },
            estructura() {
                this.$nextTick(() => {
                    this.$emit('refsInputs', this.$refs.input.filter(input => !['hidden:id'].includes(input.type) && !input.readonly && !input.visible ))
                })
            }
        },
        mounted() {
            this.init()
            this.$emit('created')
            
            // Controlar la version reducida del formulario.
            // Para la version de "compartir" se usa version reducida
            if (this.porlet.version && this.porlet.version === "lite") {
                this.versionReducida = true
            }

            // Controlar si tiene autofirma
            if (this.porlet.attr.showAutofirma) {
                this.showAutofirma = true
            }
        },
        methods: {
            foc(key, style) {
                this.$refs[key][0].classList.value = style
            },
            blur(key, style) {
                this.$refs[key][0].classList.value = style
            },
            async init () {

                this.loading = true

                try {

                    let {data} = await getEstructuraFormulario(this.porlet.relacion, this.user)

                    this.fichaInicial = data
                    this.formularioInicial = Object.keys(data.data).map(key => {
                        const el = data.data[key]
                        return (typeof el == 'object') ? el : ''
                    }).filter(el => el !== '')

                } catch (e) {
                    //console.log('Error init :: ',e)
                }

                this.loading = false

                this.crearEstructura()

            },

            crearEstructura() {

                const salida = []
				let controlKey = 0
                
				this.formularioInicial.forEach((object_base, i) => {

                    const object = {...object_base}
                    object.loading = false

					if(controlKey == 0 || ( controlKey < i )) { 

						const array = []

						if(!object.attr.hasOwnProperty('divider') || ( object.attr.hasOwnProperty('divider') && object.attr.divider)) {
							array.push(this.formularioInicial[controlKey > 0 ? controlKey + 1 : ( controlKey == 0 ? controlKey + i : (i + 1) )]) // Hay divider, termina la fila
							controlKey = 0
						} else {

							let totalCol = 0 //Acumula el ancho de cada columna por fila recorrida
                            
							while(totalCol < 24) { // Comprueba si hay hueco para meter mas campos

								controlKey = controlKey > 0 ? controlKey + 1 : ( controlKey == 0 ? controlKey + (((totalCol>0 && totalCol<24) && i==0 )?i+1 : i) : (i + 1) ) // Almaceno el siguiente indice a recorrer

                                if(this.formularioInicial[controlKey]) {

                                        const currentCol = (this.formularioInicial[controlKey].attr.col || 24)
                                        if((totalCol + currentCol) <= 24) { // Comprobar limite de columnas para cada fila
                                            
                                            array.push(this.formularioInicial[controlKey])
                                            totalCol = totalCol + currentCol

                                            //TEST
                                            if(this.formularioInicial[controlKey].attr.divider == true) {
                                                totalCol = 24
                                            }
                                            
                                        } else {

                                            totalCol = 24
                                            controlKey = controlKey - 1

                                        }
                                    
                                    
                                } else {
                                    totalCol = 24
                                }
								
							}
						}

						salida.push(array)

					} else if (controlKey == i) {
						controlKey = 0
					}
				})

                this.estructura = salida
                
            },
            
            getUnionTitle(estructura) {
                // Para campos que esten en la misma fila y deban concatenar los titulos
                let out = estructura.reduce((acum, val) => {
                    if(!acum.includes(val.title)) acum.push(val.title)
                    return acum
                },[])

                return out.join(' / ')
            },

            // Comprobar si es de tipo id o go
            isExtraType (input) {

				const types = input.format.split(':')

				if (types.length < 2) return false

				return types[1]

			},

            inputGo(input) {

                if(!input.value) return

                this.$emit('openWindow', {
					entidad: input.entidad, 
					id: input.value
				})
            },

            filter_search(data) {
                
                let obj = false

                if (data[0].title) {
                    
                    let key = `${data[0].key}_filter`
                    let obj_filter = this.objects.find(f => f.key == key)
                    if (obj_filter) {
                        obj = {
                            options: obj_filter.options,
                            value: obj_filter.options[0].value,
                            key
                        }
                    }
                }
                
                return obj
            },

            actionsByInput (input) {

                let items = []
                let _self = this
                if (input && input.actions && input.actions.length && _self.fichaInicial.actions) {
                    items = Object.values(input.actions)
                    .filter(action => action != "")
                    .map(accion => {
                        let m = _self.fichaInicial.actions[accion]
                        if (!m) return

                        return {
                            icon: m.icon,
                            titulo: m.titulo,
                            auto: m.auto || true,
                            function: m.function || null,
                            url: m.url ? m.url.replace('@@id@@',_self.id) : null
                        }
                    })
                }
                return items

            },

            // Accion tras dar a cualquier boton
            async actionForm(button) {
                
                // Validar campos
                if (this.autoFirma) {

                    if (this.formularioInicial.some(input => input.format == 'filedrag' && input.value == "")) {
                        
                        // solo es obligatorio seleccionar documento
                        this.$notify.error({
                            title: 'Error',
                            message: 'Es necesario seleccionar un documento'
                        })

                        this.autoFirma = false

                        return
                    }

                } else {

                    if(Object.keys(this.formularioInicial).some(key => this.formularioInicial[key].value == "" && this.formularioInicial[key].obligatorio == 1)) {

                        this.$notify.error({
                            title: 'Error',
                            message: 'Rellena los campos obligatorios'
                        })

                        return
                    }
                }

                this.loading = true

                try {

                    let resp = await postActionData(button.accion, this.fichaInicial.data, button.metodo.toLowerCase() || 'post')

                    let data = resp.data
                    
                    this.$emit('afterActions', data)

                    if (resp && resp.status == 200) {
                        this.resetearFormulario()
                    }

                    this.$router.push({path: '/'})

                } catch (e) {

                    console.log('Error init :: ',e)
                    this.$notify.error({
						title: 'Error',
						message: 'Ha ocurrido un error'
					});
                }

                this.autoFirma = false

                this.loading = false
            },
            input(data) {
                console.log('input: ', data)
            },
            resetearFormulario() {
                this.estructura.forEach((linea) => {
                    linea.forEach((input) => {
                        if(input.format == 'switch') {
                            input.value = 0
                        } else {
                            if(input.title === 'Tipo firma') {
                                input.value = 1
                            } else {
                                input.value = ""
                            }
                        }
                    }) 
                })
            },

            // Cerrar modal de autofirma
            handleCloseAutofirma() {
                this.estructura.filter(f => f[0].seccion == 'autofirma').forEach(inputs => {
                    inputs.forEach(input => {
                        input.value = ""
                    })
                })
            }
        }
	}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
form {
    width: 100%;
}

.formulario-secciones {
    display: flex;
    flex-flow: column;
    position: relative;

    .secciones {
        display: flex;
        flex-flow: column;
        @media(min-width: 768px) { flex-flow: row; }
        
        > section {
            width: 100%;
            @media(min-width: 768px) { width: calc(100% / 3);}

            .section-title {
                margin: 1.2rem 0.6rem;
                font-weight: 500;
                display: flex;
                align-items: center;
                min-height: 34px;
                &.no-title {
                    display: none;
                    @media(min-width: 768px) { display: block; }
                }
                > .section-title-content {
                    display: flex;
                    align-items: center;
                    flex-grow: 1;

                    > div {
                        border-radius: 50%;
                        width: 30px;
                        height: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 2px solid $--color-primary;
                        color: $--color-primary;
                        font-weight: 600;
                        margin-right: 0.5rem;
                    }
                    p {
                        margin: 0;
                        color: $--color-primary;
                    }
                }
                i {
                    color: #99999961;
                    font-size: 1.5rem;
                }
            }
            
        }
    }

    .form-lite {
        display: flex;
        align-items: center;
        flex-flow: column;
        position: absolute;
        background-color: white;
        width: -webkit-fill-available;
        height: 100%;
        z-index: 9;
        padding: 0 20px;
        img {
            width: 100px;
            margin: 90px 0px 90px 0px;
        }
        button {
            margin: 10px 0px 25px 0px;
            width: 100%;
            padding: 15px;
            font-size: 1.12rem;
        }
    }
}

.dialog-autofirma {
    .el-dialog {
        width: 90%;
        @media (min-width: 768px) {
            width: 500px;
        }
    }
}

ul.formulario-nuevo-documento {
    padding: 0px;
    margin: 0.5rem 0rem;
    list-style: none;
    background-color: white;
    overflow: hidden;
    border-radius: 6px;
    flex-direction: row;
    &.mode-editor {
        .form-group {
            position: relative;
            height: 51.78px;
        }
    }
    > li {
        padding: 0rem 0.5rem 0.3rem 0.5rem;
        flex-flow: row;
        &.no-visible,
        &.hidden  {
            display: none!important;
        }
        &.visible {
            display: flex;
        }
        > div {
            flex-grow: 1;
        }
        .form-group {
            border: 1px solid #EBEEF5;
            border-radius: 6px;
            display: flex;
            flex-flow: column;
            overflow: hidden;
            &:hover {
                border: 1px solid #DCDFE6;
                .form-input form .holder > div:last-child .buttons {
                    display: flex;
                }
                .form-input .buttons button {
                    display: flex;
                }
            }
            &.focused {
                background-color: $--color-background!important;
                border: 1px solid $--color-primary!important;
                label {
                    top: 0px;
                }
                &.obligatorio {
                    background-color: #fde2e2!important;
                    border: 1px solid #F56C6C !important;
                }
            }
            &.form-group-merge {
                flex-flow: row;
                .form-group {
                    border: 0px;
                }
                .holder {
                    position: unset!important;
                }
            }
            label {
                flex-grow: 1;
                padding: 0.4rem 0.5rem 0rem;
                font-size: 0.85rem;
                color: #909090;
                height: 19px;
                overflow: hidden;
            }
            .form-input {
                flex-grow: 1;
                display: flex;
                .el-col {
                    &.height-fit {
                        height: fit-content!important;
                    }
                }
                form {
                    &:hover {
                        background-color: transparent;
                    }
                    &.editable {
                        .holder .label {
                            color: $--color-primary;
                        }
                    }
                    .holder {
                        position: relative;
                        .label {
                            margin-bottom: 0.4rem;
                            line-height: 20px;
                            color: #002b56;
                            font-weight: 600;
                            .truncate.placeholder {
                                height: 20px!important;
                            }
                            textarea {
                                font-weight: 600;
                            }
                        }
                        input {
                            border: 0px!important;
                            border-color: transparent;
                            background-color: transparent;
                            margin-bottom: 0.4rem;
                            height: 20px;
                            line-height: 20px;
                        }
                        textarea {
                            border-color: transparent;
                            background-color: transparent;
                        }
                        > div:last-child {
                            //position: relative;
                            .buttons {
                                display: flex;
                                position: absolute;
                                right: 0;
                                bottom: 0;
                                display: none;
                                background-color: white;
                                border-radius: 6px;
                                border: 0px;
                            }
                        }
                    }
                    .buttons {
                        button {
                            display: none;
                            margin: 1px 1px;
                            border-radius: 5px;
                            padding: 7px 9px;
                            max-height: 24px;
                            max-width: 30px;
                            border: 0px;
                        }
                    }
                }
            }
        }
        > ul {
            padding: 0;
        }
    }
}

.formulario-buttons {
    padding: 0rem 0.5rem 0.5rem 0.5rem;
    display: flex;
}

.placeholder {
    color: rgb(187, 187, 187);
}
</style>